import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { RoutePaths } from '@utils/route.utils';
import { SanitizePipe } from '@pipes/sanitize-html.pipe';

@Component({
  selector: 'app-two-factor-auth-faq',
  imports: [
    TranslateModule,
    MatIcon,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    SanitizePipe
  ],
  templateUrl: './two-factor-auth-faq.component.html',
  styleUrl: './two-factor-auth-faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TwoFactorAuthFaqComponent {
  isMobileView = input(false);
  panelOpenState = signal(false);
  contactPageUrl = RoutePaths.Core.Contact.absolutePath;

  scrollIntoView(htmlDivElem: HTMLDivElement) {
    htmlDivElem.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
